import { render } from "./PageSpinner.vue?vue&type=template&id=378ef736&scoped=true"
import script from "./PageSpinner.vue?vue&type=script&lang=js"
export * from "./PageSpinner.vue?vue&type=script&lang=js"

import "./PageSpinner.vue?vue&type=style&index=0&id=378ef736&lang=scss&scoped=true"

import exportComponent from "/Users/yalemarc/Documents/yaleapps/simplify-photo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378ef736"]])

export default __exports__